<form [formGroup]="form" class="style-form-default">
  <!-- <div class="style-input-default" data-text="Asignar a *" [ngClass]="{error: verificateInput('asignar')}">
      <input type="text" placeholder="Asignar a" formControlName="asignar">
    </div> -->

  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Código y agencia involucrada *</mat-label>
      <input
        type="text"
        formControlName="codigo_agencia"
        matInput
        placeholder="Código y agencia involucrada"
      />
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default" data-text="Código y agencia involucrada *" [ngClass]="{error: verificateInput('codigo_agencia')}">
      <input type="text" placeholder="Código y agencia involucrada" formControlName="codigo_agencia">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>N° de SAKE *</mat-label>
      <input
        onlyNumber
        type="text"
        formControlName="sake"
        matInput
        placeholder="N° de SAKE"
      />
      <mat-error *ngIf="form.get('sake').hasError('pattern')"
        >El SAKE es <strong>invalido</strong></mat-error
      >
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default" data-text="N° de SAKE *" [ngClass]="{error: verificateInput('sake')}">
      <input type="text" placeholder="N° de SAKE" formControlName="sake">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>C.I. Empleado, NM *</mat-label>
      <input
        type="text"
        formControlName="ci_empleado"
        matInput
        placeholder="V12345678"
      />
      <mat-error *ngIf="form.get('ci_empleado').hasError('pattern')"
        >El C.I. es <strong>invalido</strong></mat-error
      >
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default" data-text="C.I. Empleado, NM *" [ngClass]="{error: verificateInput('ci_empleado')}">
      <input type="text" placeholder="C.I. Empleado, NM" formControlName="ci_empleado">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Empleado involucrado *</mat-label>
      <input
        type="text"
        formControlName="empleado"
        matInput
        placeholder="Empleado involucrado"
      />
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default" data-text="Empleado involucrado *" [ngClass]="{error: verificateInput('empleado')}">
      <input type="text" placeholder="Empleado involucrado" formControlName="empleado">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Cargo *</mat-label>
      <input type="text" formControlName="cargo" matInput placeholder="Cargo" />
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default" data-text="Cargo *" [ngClass]="{error: verificateInput('cargo')}">
      <input type="text" placeholder="Cargo" formControlName="cargo">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Nombre del cliente afectado *</mat-label>
      <input
        type="text"
        formControlName="cliente"
        matInput
        placeholder="Nombre del cliente afectado"
      />
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default" data-text="Nombre del cliente afectado *" [ngClass]="{error: verificateInput('cliente')}">
      <input type="text" placeholder="Nombre del cliente afectado" formControlName="cliente">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>C.I./RIF afectado *</mat-label>
      <input
        type="text"
        formControlName="ci_cliente"
        matInput
        ciRif
        placeholder="J123456789"
      />
      <mat-error *ngIf="form.get('ci_cliente').hasError('pattern')"
        >El C.I./RIF es <strong>invalido</strong></mat-error
      >
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default" data-text="C.I./RIF afectado *" [ngClass]="{error: verificateInput('ci_cliente')}">
      <input type="text" placeholder="C.I./RIF afectado" formControlName="ci_cliente">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Fecha de Alerta *</mat-label>
      <input
        type="date"
        formControlName="fecha_evento"
        matInput
        placeholder="Fecha del evento"
      />
    </mat-form-field>
    <mat-error
      class="error"
      *ngIf="form.get('fecha_evento').hasError('required')"
      ><strong>Valor requerido</strong></mat-error
    >
  </div>
  <!-- <div class="style-input-default" data-text="Fecha del evento *" [ngClass]="{error: verificateInput('fecha_evento')}">
      <input type="date" formControlName="fecha_evento">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Cuenta afectada *</mat-label>
      <input
        type="text"
        formControlName="cuenta"
        matInput
        onlyNumber
        placeholder="Cuenta afectada"
      />
      <mat-error *ngIf="form.get('cuenta').hasError('pattern')"
        >La cuenta es <strong>invalida</strong></mat-error
      >
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default column-complete" data-text="Cuenta afectada *" [ngClass]="{error: verificateInput('cuenta')}">
      <input type="text" placeholder="Cuenta afectada" formControlName="cuenta">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Involucrado externo *</mat-label>
      <input
        type="text"
        formControlName="involucrado"
        matInput
        placeholder="Involucrado externo"
      />
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default" data-text="Involucrado externo *" [ngClass]="{error: verificateInput('involucrado')}">
      <input type="text" placeholder="Involucrado externo" formControlName="involucrado">
    </div> -->
  <!-- <div class="style-input-default" data-text="C.I./RIF Involucrado externo *" [ngClass]="{error: verificateInput('ci_involucrado')}">
      <input type="text" placeholder="C.I./RIF Involucrado externo" formControlName="ci_involucrado">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>C.I./RIF Involucrado externo</mat-label>
      <input
        type="text"
        formControlName="ci_involucrado"
        matInput
        ciRif
        placeholder="Ingrese su documento"
      />
      <mat-error *ngIf="form.get('ci_involucrado').hasError('pattern')"
        >El C.I./RIF es <strong>invalido</strong></mat-error
      >
    </mat-form-field>
  </div>
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Denuncia</mat-label>
      <input
        type="text"
        formControlName="denuncia"
        matInput
        placeholder="Denuncia"
      />
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default" data-text="Denuncia *" [ngClass]="{error: verificateInput('denuncia')}">
      <input type="text" placeholder="Denuncia" formControlName="denuncia">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Descripción...</mat-label>
      <input
        type="text"
        formControlName="descripcion"
        matInput
        placeholder="Descripción..."
      />
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default column-complete" data-text="Descripción *" [ngClass]="{error: verificateInput('descripcion')}">
      <textarea rows="4" placeholder="Descripción..." formControlName="descripcion"></textarea>
    </div> -->

  <!-- <div class="style-input-default" data-text="Tipo de caso *" [ngClass]="{error: verificateInput('tipo_caso')}">
      <input type="text" placeholder="Tipo de caso" formControlName="tipo_caso">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Monto en riesgo</mat-label>
      <input
        type="text"
        formControlName="monto_riesgo"
        matInput
        Currency
        placeholder="Monto en riesgo"
      />
      <mat-error *ngIf="form.get('monto_riesgo').hasError('pattern')"
        >El monto es <strong>invalido</strong></mat-error
      >
    </mat-form-field>
  </div>
  <!-- <div class="style-input-default" data-text="Monto en riesgo *" [ngClass]="{error: verificateInput('monto_riesgo')}">
      <input type="text" placeholder="Monto en riesgo" formControlName="monto_riesgo">
    </div> -->
  <div>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Monto recuperado</mat-label>
      <input
        type="text"
        formControlName="monto_recuperado"
        matInput
        Currency
        placeholder="Monto recuperado"
      />
      <mat-error *ngIf="form.get('monto_recuperado').hasError('pattern')"
        >El monto es <strong>invalido</strong></mat-error
      >
    </mat-form-field>
  </div>
  <div class="flex">
    <mat-form-field
      *ngIf="!form.value.check"
      style="width: 100%"
      appearance="outline"
    >
      <mat-label>Tipo de caso</mat-label>
      <mat-select formControlName="tipo_caso" placeholder="Region 1">
        <mat-option *ngFor="let value of typeCaseOptions" [value]="value">
          {{ value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field
      *ngIf="form.value.check"
      style="width: 100%"
      appearance="outline"
    >
      <mat-label>Ingresa el tipo de caso</mat-label>
      <input
        type="text"
        formControlName="tipo_caso"
        matInput
        placeholder="Tipo de caso"
      />
    </mat-form-field>
    <mat-checkbox class="check" formControlName="check">Otro</mat-checkbox>
  </div>
  <!-- <div class="style-input-default" data-text="Monto recuperado *" [ngClass]="{error: verificateInput('monto_recuperado')}">
      <input type="text" placeholder="Monto recuperado" formControlName="monto_recuperado">
    </div> -->
</form>
